import apiClient from '@/services/api/apiClient';
import { QueryParams } from '@/model';
import { buildApiUrl } from '../utils';
import {
  GetMediaCategoryVideoResponse,
  PostMediaCategoryVideoResponse,
  GetMediaCategoryVideoByIdResponse,
  PutMediaCategoryVideoResponse,
} from '../response/category-video';

export class CategoryVideoService {
  static getCategoryVideos(params?: QueryParams) {
    return apiClient.get<GetMediaCategoryVideoResponse>(buildApiUrl('/api/v1/media/category-video'), params);
  }

  static postCategoryVideo(data: any) {
    return apiClient.post<PostMediaCategoryVideoResponse>(buildApiUrl('/api/v1/media/category-video'), data);
  }

  static getCategoryVideoById(id: string) {
    const url = buildApiUrl('/api/v1/media/category-video/:id', { id });
    return apiClient.get<GetMediaCategoryVideoByIdResponse>(url, undefined);
  }

  static putCategoryVideo(id: string, data: any) {
    const url = buildApiUrl('/api/v1/media/category-video/:id', { id });
    return apiClient.update<PutMediaCategoryVideoResponse>(url, data);
  }

  static deleteCategoryVideo(id: string) {
    const url = buildApiUrl('/api/v1/media/category-video/:id', { id });
    return apiClient.delete<void>(url, undefined);
  }
}
